import { useQuery } from '@apollo/client'
import { useOnErrorAuto } from '@/utils/hooks'
import { ALL_FORM_TEMPLATES_SHALLOW_QUERY } from './queries'
import type {
  AllFormTemplatesShallowQuery,
  AllFormTemplatesShallowQueryVariables,
} from './types.graphql'
import { getIconShortcutsFromFormTemplates } from './util'

/**
 * Returns the form templates flagged as sidebar/menu shortcuts as
 * `IconShortcutProps`, ready to be rendered on the dashboard.
 */
export function useFormcreatorMenuShortcuts() {
  const onErrorAuto = useOnErrorAuto()

  const { data, loading } = useQuery<
    AllFormTemplatesShallowQuery,
    AllFormTemplatesShallowQueryVariables
  >(ALL_FORM_TEMPLATES_SHALLOW_QUERY, {
    variables: { excludeArchived: true },
    onError: onErrorAuto(),
  })

  const templates = data?.allFormTemplates.edges.map(edge => edge.node) ?? []
  const links = getIconShortcutsFromFormTemplates(templates)

  return { links, loading }
}
